const BASE = process.env.REACT_APP_API_URL_DEFAULT



const ENDPOINT_MAP = {
  ADN: {
   nextStatus:`${BASE}adn/OrderDetail/updateStage`,
    getAllStages:`${BASE}adn/OrderDetail/getAllStages`,
  },
  AOA: {
   nextStatus:`${BASE}aoa/AOAOrderDetail/updateStage`,
    getAllStages:`${BASE}aoa/AOAOrderDetail/getAllStages`,
  },
};

export const getStagesUrls = (domain = "ADN") =>
  ENDPOINT_MAP[domain] || ENDPOINT_MAP.ADN;